import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { LandingService } from 'src/app/rest_services/landing.service';
import { phoneNumberValidator } from 'src/app/validators/phone-number.validator';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  contactForm: FormGroup;

  constructor(private recaptchaV3Service: ReCaptchaV3Service,private formBuilder: FormBuilder,
    private mailService: LandingService
  ) {
    this.removeCssById("css_landing");
    this.loadStyle("assets/index/css/vendor/font-awesome.css");
    this.loadStyle("assets/index/css/vendor/slick.css");
    this.loadStyle("assets/index/css/vendor/slick-theme.css");
    this.loadStyle("assets/index/css/vendor/animate/animate.min.css");
    this.loadStyle("assets/index/app.css");
    this.loadScript("assets/index/app.js");
    this.loadScript("assets/index/js/slick.min.js");

    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required],
      phone: ['', [Validators.required, phoneNumberValidator()]],
      email: ['', [Validators.required, Validators.email, mailService.noDisposableEmail()]],
      object: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(3)]],
      structure: ["Non précisée", Validators.required],
      message: ['', Validators.required],
      conditions: ['', Validators.required]
    });
   }

  mobile:any=false;
  medium:any=false;
  loading:any=false;
  ngOnInit(): void {
    $("#preloader").show("slow");
    $(".logo_navbar").css("max-width","8% !important");
    
    this.preloader();
    setTimeout(()=>{
      let footer:any = document.getElementsByClassName("footer-section");      
      footer[0].style.display = "none";
      $("html, body").animate({scrollTop:0});
    },2000);
    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
      if (window.screen.width > 668) this.medium = true;
    }else {
      this.mobile = false;
    }
    $(document).ready(function(){
      $(".mobile-nav__wrapper").removeClass("expanded");
      $("body").removeClass("locked");
    });
  }

  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    var scriptsTags = document.getElementsByTagName('script');
    for (var i = scriptsTags.length; i--;) {
        if (scriptsTags[i].src != scripts) {
          document.getElementsByTagName("body")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  public loadStyle(link:string) {
    let node = document.createElement("link");
    node.href = link;
    node.type = "text/css";
    node.id = "css_landing";
    node.rel ="stylesheet";
    var linksTags = document.getElementsByTagName('link');
    for (var i = linksTags.length; i--;) {
        if (linksTags[i].href != link) {
          document.getElementsByTagName("head")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  preloader () {
    setTimeout(function () {
      $("#preloader").hide("slow");
    }, 1500);
    setTimeout(function () {
      $(".footer-section").css("display","none !important")
    }, 5000);
  }
  removeCssById(id: string) {
    const styleElement = document.getElementById(id);
    if (styleElement) {
      styleElement.remove(); // Removes the element from the DOM
    } else {
      console.warn(`No CSS found with id '${id}'`);
    }
  };

  send(): void {
    this.loading = true;
    $("#spinner-mf").show();
    $(".cus-btn-icon").hide();
    if (this.contactForm.invalid || !this.contactForm.value.conditions) {
      this.contactForm.markAllAsTouched();
      this.showAlert('.alert-danger');
      this.loading = false;
      return;
    }

    this.recaptchaV3Service.execute('contactForm').subscribe({
      next: async (token: string) => {
        const result = await this.mailService.sendContact(this.contactForm.value, token);
        if (result === 'sent') {
          this.showAlert('.alert-success');
          this.loading = false;
          this.contactForm.reset({ structure: 'Non précisée' });
        } else {
          this.showAlert('.alert-danger');
          this.loading = false;
        }
        $("#spinner-mf").hide();
        $(".cus-btn-icon").show();
      },
      error: () => {
        this.showAlert('.alert-danger');
        this.loading = false;
      }
    });
  }

  private showAlert(selector: string): void {
    $(selector).addClass('fadeIn').removeClass('fadeOut');
    setTimeout(() => $(selector).removeClass('fadeIn'), 7000);
  }
}
